var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseTrainingProgramForm',{attrs:{"trainingProgramObject":_vm.trainingProgram,"formActionName":"إنشاء المسار"},on:{"trainingProgramSubmitted":function (submittedTB, video) { return _vm.sendTrainingProgramData(submittedTB, video); }}})}
var staticRenderFns = []

export { render, staticRenderFns }